<template>
    <el-upload
            ref="upload"
            :action="action"
            with-credentials
            :file-list="fileList"
            :multiple="multiple"
            :limit="limit"
            :on-success="onSuccess"
            :on-remove="onRemove"
            :before-upload="beforeUpload"
            :on-preview="onPreview"
            :on-exceed="onExceed"
            v-bind="$attrs">
        <el-button size="small" type="primary">点击上传</el-button>
        <div v-if="tip" slot="tip">{{tip}}</div>
    </el-upload>
</template>
<script>
    import config from '../../config.js'
    import bytes from 'bytes'

    export default {
        props: ['value', 'tip', 'multiple', 'limit', 'maxFileSize', 'fileSuffixes'],
        inheritAttrs: false,
        data() {
            return {
                action: config.backendUrl + '/files'
            }
        },
        computed: {
            fileList() {
                if (!this.value) return []
                else if (Array.isArray(this.value)) {
                    return this.value.map(item => {
                        const url = config.backendUrl + '/files?path=' + encodeURIComponent(item.path)
                        return {name: item.name, url, path: item.path}
                    })
                } else {
                    const url = config.backendUrl + '/files?path=' + encodeURIComponent(this.value.path)
                    return [{name: this.value.name, url, path: this.value.path}]
                }
            },
            maxFileSizeValue() {
                return this.maxFileSize ? bytes.parse(this.maxFileSize) : null
            },
            fileSuffixesSet() {
                if (!this.fileSuffixes) return null
                const set = new Set()
                for (const suffix of this.fileSuffixes.split(/\s*[,;]\s*/)) {
                    if (suffix.length > 0) set.add(suffix.toLowerCase())
                }
                return set
            }
        },
        methods: {
            onSuccess(res, file, fileList) {
                file.path = res.path
                file.name = res.name
                file.url = config.backendUrl + '/files?path=' + encodeURIComponent(res.path)
                this.onFileListChange(fileList)
            },
            onRemove(file, fileList) {
                this.onFileListChange(fileList)
            },
            onFileListChange(fileList) {
                if (fileList.length === 0) {
                    this.$emit('input', null)
                } else if (this.limit === 1) {
                    this.$emit('input', {name: fileList[0].name, path: fileList[0].path})
                } else {
                    this.$emit('input', fileList.map(e => {
                        return {name:e.name, path:e.path}
                    }))
                }
            },
            beforeUpload(file) {
                if (this.fileSuffixesSet) {
                    const idx = file.name.lastIndexOf('.')
                    if (idx === -1 || !this.fileSuffixesSet.has(file.name.substring(idx + 1).toLowerCase())) {
                        this.$message.error('请上传指定类型的文件！')
                        return false
                    }
                }
                if (this.maxFileSizeValue && file.size > this.maxFileSizeValue) {
                    this.$message.error('文件大小超过限制！')
                    return false
                }
                return true
            },
            onPreview(file) {
                window.open(file.url, '_blank')
            },
            onExceed() {
                this.$message.error('超出文件个数限制！')
            }
        }
    }
</script>
